import {AfterContentInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationLink} from '../navigation-bar/navigation-link';
import {ProductDetailsNavigationLinkService} from '../navigation-bar/product-details-navigation-link.service';
import {Observable} from 'rxjs';
import {Product} from '@spartacus/core';
import {CurrentProductService} from '@spartacus/storefront';
import {DcpProductUtilitiesService} from '../../services/dcp-product-utilities.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-product-details-section',
  template: '',
})
export class ProductDetailsSectionComponent implements OnInit, OnDestroy, AfterContentInit {

  product$: Observable<Product>;
  product: Product;
  isSapProduct: boolean;
  navLink: NavigationLink = {
    headline: '',
    id: ''
  };

  constructor(
    protected currentProductService: CurrentProductService,
    protected changeDetection: ChangeDetectorRef,
    protected productDetailsNavigationLinkService: ProductDetailsNavigationLinkService,
    protected dcpProductUtilitiesService: DcpProductUtilitiesService
  ) {
  }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
    this.product$.pipe(untilDestroyed(this)).subscribe(product => {
      this.product = product;
      this.isSapProduct = this.dcpProductUtilitiesService.isSapProduct(product);
      this.prepareData();
      this.changeDetection.detectChanges();
      if (this.isVisible()) {
        this.productDetailsNavigationLinkService.addNavigationLink(this.navLink);
      } else {
        this.productDetailsNavigationLinkService.removeNavigationLink(this.navLink);
      }
    });
  }

  ngOnDestroy(): void {
    this.productDetailsNavigationLinkService.removeNavigationLink(this.navLink);
  }

  ngAfterContentInit(): void {
    this.productDetailsNavigationLinkService.sortByOffset();
  }

  isVisible(): boolean {
    return false;
  }

  prepareData(): void {
    // is being overwritten
  }
}
